"use client";

import { useEffect } from "react";

// Registra el service worker (public/sw.js) en scope "/" para TODA la app.
//
// Hasta ahora el SW solo se registraba en /instalar (install-experience.tsx) y
// en los flujos SOS (lib/sos/notifications.ts). Un operador que abrió la app
// sin pasar por /instalar no tenía SW → sin cascarón offline (reload sin red =
// dinosaurio). Montado en el root layout, garantiza el SW en cualquier sesión,
// que es lo que habilita el caching offline (ver public/sw.js).
//
// Idempotente: registrar el mismo script/scope repetido es no-op para el
// browser. Best-effort — si falla (contexto inseguro, browser sin SW), no rompe
// nada; la app anda igual, solo sin cascarón offline.
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
      return;
    }
    // Tras la carga, sin competir con el trabajo del arranque.
    const register = () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
    };
    if (document.readyState === "complete") {
      register();
    } else {
      window.addEventListener("load", register, { once: true });
      return () => window.removeEventListener("load", register);
    }
  }, []);

  return null;
}
